// ─────────────────────────────────────────────
// src/store/uiStore.js
// Global UI state — modals, sidebar, theme
// ─────────────────────────────────────────────
import { create } from 'zustand';

export const useUIStore = create((set) => ({
  // Auth modal
  authModal:     null, // null | 'register' | 'login'
  openAuthModal: (mode) => set({ authModal: mode }),
  closeAuthModal: ()    => set({ authModal: null }),

  // Sidebar
  sidebarCollapsed: false,
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),

  // Mobile menu
  mobileMenuOpen: false,
  toggleMobileMenu: () => set((s) => ({ mobileMenuOpen: !s.mobileMenuOpen })),
  closeMobileMenu:  ()  => set({ mobileMenuOpen: false }),

  // Notifications panel
  notifPanelOpen: false,
  toggleNotifPanel: () => set((s) => ({ notifPanelOpen: !s.notifPanelOpen })),

  // Theme
  theme: 'dark',
  toggleTheme: () => set((s) => ({ theme: s.theme === 'dark' ? 'light' : 'dark' })),
}));
